import CommentsForm from "../components/CommentsForm";

const AddCommentPage = () => {
  document.title = "Оставить комментарий | Кампания из Эвенглена";
  return <CommentsForm />;
};

export default AddCommentPage;
